module.exports = __webpack_public_path__ + "img/priceup.f28f92ee.svg";